// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as MediaQuery$PorterinUtils from "../../../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as NextImage$PorterinFeature from "../../../../../ui/components/NextImage.mjs";
import * as LoginPictureModuleScss from "../../styles/LoginPicture.module.scss";

var styles = LoginPictureModuleScss;

function LoginPictureCmp(Props) {
  var hide_image = Props.hide_image;
  var isDesktop = MediaQuery$PorterinUtils.useMediaQuery("(min-width: 1024px)");
  return React.createElement("div", {
              className: hide_image ? styles["login-picture-wrapper-hidden"] : styles["login-picture-wrapper"]
            }, React.createElement("div", {
                  className: styles["picture-wrapper"]
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: "https://nest-platform-assets.porter.in/auth_image_mob_05e47cdef3/auth_image_mob_05e47cdef3.png",
                      height: isDesktop ? 265.0 : 445.0,
                      width: isDesktop ? 380.0 : 594.0,
                      quality: 100.0,
                      alt: "Porter Logo Blue"
                    })));
}

var make = LoginPictureCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
